import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar, Typography } from "@material-ui/core/";
import MenuSefaz from "../../components/MenuSefaz/MenuSefaz.jsx";
import logoPrefeitura from "../../assets/img/logo-prefeitura.svg";
import Constants from "../../helper/resources/Constants";
import { useSelector } from "react-redux";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 10
  },
  appBar: {
    background: "#0066b2"
  },
  header: {
    minHeight: 38
  },
  logoPrefeitura: {
    width: 25
  },
  title: {
    flexGrow: 1,
    fontSize: 12,
    marginLeft: 5
  },
  linkHeaderSefaz: {
    color: "#FFF",
    textDecoration: "none",
    display: "flex",
    transition: 'all .2s',
    "&:hover": {
      transform: "scale(1.05)",
    }    
  }
}));

const config = window._env_;

export default function HeaderAppBar() {
  const classes = useStyles();
  
  const profile = useSelector(({ auth }) => auth.profile);
  
  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.header}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.salvador.ba.gov.br"
            className={classes.linkHeaderSefaz}
          >
            <img
              src={logoPrefeitura}
              className={classes.logoPrefeitura}
              alt="Logo Prefeitura"
            />
            <Typography variant="h6" className={classes.title}>
              Prefeitura Municipal de Salvador - Secretaria da Fazenda
            </Typography>
          </a>
        </Toolbar>
      </AppBar>
      <MenuSefaz
          Model={profile}
          Sistema={Constants.NOME_SISTEMA}
          ApiSefaz={config.API_SEFAZ}
          UrlRetorno={config.LOGOUT_REDIRECT_URI}
      />
    </div>
  );
}
